import { PathLoadSpecification } from "./ICandyApiClient";

export function convertPathLoadSpecificationToString(spec: PathLoadSpecification): string {
    return (
        (spec.skip ? "-" : "") +
        (spec.pathOrPathPrefix === "*" ? spec.pathOrPathPrefix : spec.pathOrPathPrefix.toLegacyPath())
    );
}
